export const SIZE = [
  'small',
  'medium',
  'large'
]

export const VARIATION = [
  'transparent',
  'block'
]

export const ALIGNMENT = [
  'left',
  'center',
  'right'
]

export const FORMAT = [
  'hour',
  'minute',
  'second'
]

export const LABEL_POSITION = [
  'left',
  'top'
]
